export default __webpack_public_path__ + "static/media/product-tour-slide-1.a1f856be.svg";